import React, { useState } from 'react';
import { Modal, Textarea } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { ASSISTANT_FEEDBACK_MAX_LENGTH, ASSISTANT_FEEDBACK_MIN_LENGTH } from 'shared-models/browser';
import { Button } from '../Button';
import classes from './assistant-panel.module.scss';

const SUCCESS_MESSAGE = 'המשוב נשלח, תודה!';
const FAILURE_MESSAGE = 'שליחת המשוב נכשלה. נסו שוב.';

export type AssistantFeedbackModalProps = {
  testIdPrefix: string;
  opened: boolean;
  onClose: () => void;
  sendFeedback: (message: string) => Promise<void>;
  zIndex?: number;
};

export const AssistantFeedbackModal: React.FC<AssistantFeedbackModalProps> = ({
  testIdPrefix,
  opened,
  onClose,
  sendFeedback,
  zIndex,
}) => {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const submit = async () => {
    const trimmed = message.trim();
    if (trimmed.length < ASSISTANT_FEEDBACK_MIN_LENGTH || sending) return;
    setSending(true);
    try {
      await sendFeedback(trimmed);
      notifications.show({ color: 'green', message: SUCCESS_MESSAGE, autoClose: 3000 });
      setMessage('');
      onClose();
    } catch {
      notifications.show({ color: 'red', message: FAILURE_MESSAGE, autoClose: 4000 });
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="הערה לשיפור?"
      size="md"
      centered
      dir="rtl"
      zIndex={zIndex}
      closeButtonProps={{ 'data-testid': `${testIdPrefix}-feedback-close` } as Record<string, string>}
    >
      <div className={classes.feedback} data-testid={`${testIdPrefix}-feedback-modal`}>
        <Textarea
          value={message}
          onChange={(event) => setMessage(event.currentTarget.value)}
          placeholder="ספרו לנו מה לא עבד או מה כדאי לשפר"
          maxLength={ASSISTANT_FEEDBACK_MAX_LENGTH}
          autosize
          minRows={4}
          maxRows={8}
          data-testid={`${testIdPrefix}-feedback-input`}
        />
        <div className={classes.feedbackActions}>
          <Button
            variant="confirm"
            loading={sending}
            loadingLabel="שולח"
            disabled={message.trim().length < ASSISTANT_FEEDBACK_MIN_LENGTH}
            dataTestId={`${testIdPrefix}-feedback-submit`}
            onClick={() => void submit()}
          >
            שלח
          </Button>
        </div>
      </div>
    </Modal>
  );
};
